import * as React from "react";
import { forwardRef } from "react";
const SvgErrorOutlined = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M13.87 6.468a.18.18 0 0 0-.178-.179l-1.473.007L10 8.941 7.784 6.298l-1.476-.006a.178.178 0 0 0-.178.178c0 .043.015.083.042.116l2.904 3.46-2.904 3.458a.18.18 0 0 0 .136.295l1.476-.007L10 11.147l2.217 2.642 1.473.007a.178.178 0 0 0 .179-.178.186.186 0 0 0-.043-.117l-2.9-3.457 2.905-3.46a.179.179 0 0 0 .04-.116Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10 0C4.478 0 0 4.478 0 10s4.478 10 10 10 10-4.478 10-10S15.522 0 10 0Zm0 18.304A8.305 8.305 0 0 1 1.696 10 8.305 8.305 0 0 1 10 1.696 8.305 8.305 0 0 1 18.304 10 8.305 8.305 0 0 1 10 18.304Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgErrorOutlined);
export default ForwardRef;
